import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import DirectionSix from "./directions/DirectionSix";
import AxosLanding from "./axos/Landing";
import AxosQuiz from "./axos/Quiz";
import AxosAdvertorial from "./axos/Advertorial";
import AxosListicle from "./axos/Listicle";
import AxosEmails from "./axos/Emails";
import AxosReport from "./axos/Report";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<DirectionSix />} />
        <Route path="/axos" element={<AxosLanding />} />
        <Route path="/axos/quiz" element={<AxosQuiz />} />
        <Route path="/axos/advertorial" element={<AxosAdvertorial />} />
        <Route path="/axos/listicle" element={<AxosListicle />} />
        <Route path="/axos/emails" element={<AxosEmails />} />
        <Route path="/axos/report" element={<AxosReport />} />
        <Route path="*" element={<DirectionSix />} />
      </Routes>
    </BrowserRouter>
  );
}
